@if(!menuloading()) {
<div class="stiky">
    @if(mymenu.isDefault2()) {
    <clever-header2 [isBooking]="isBooking"></clever-header2>
    }
</div>
}